
import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const useStudentsList = (searchTerm = '') => {
  const { toast } = useToast();
  
  // Use React Query for efficient caching and state management
  const { 
    data: students = [], 
    isLoading: loading, 
    error, 
    refetch 
  } = useQuery({
    queryKey: ['students-list'],
    queryFn: async () => {
      
      const { data, error } = await supabase
        .from('students')
        .select(`
          id,
          name,
          class,
          email,
          phone,
          student_activities(
            activity_id,
            status
          )
        `)
        .order('name');
      
      if (error) throw error;
      
      return data || [];
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });

  // Filter students client-side based on search term
  const filteredStudents = searchTerm 
    ? students.filter((student: any) =>
        student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        student.class.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : students;

  return { 
    students: filteredStudents, 
    isLoading: loading, 
    error: error ? (error as Error).message : null,
    refetch 
  };
};
